import React from "react"

import { Container, Row, Col } from 'reactstrap'
import Link from '../components/link'
import Layout from "../components/layout"
import SEO from "../components/seo"
import { FaServicestack } from 'react-icons/fa'
import Slider from '../components/slider'
import Box from '../components/box'
import Hr from '../components/hr'
import Button from '../components/btn'
import styled from 'styled-components'
import Image1 from '../assets/images/Medimage Lois-16.jpg'
import Image2 from '../assets/images/Medimage Lois-17.jpg'

let StyledBackground = styled.div`
  background: linear-gradient(to bottom,#f9fbfd 0,#fff 100%);
`

let Service = ({title, link, Icon = FaServicestack}) => (
  <Col  className="flex-column align-items-center" style={{wordBreak: 'break-word'}}>
    <Link to={link}>
      <Box>
        <Icon size={30}/>
        <h4 className="mt-3">{title}</h4>
      </Box>
    </Link>
  </Col>
)

let Imagine = ({sursa}) => (
  <Col>
    <img src={sursa} alt="medimage lois" style={{width: "90%"}}/>
  </Col>
)

export default () => (
  <Layout>
    <SEO title="Dr Lois"/>
    <Slider author=""/>
    <Container className="py-5">
      <div className="text-center">
        <h4 className="text-primary">Ai nevoie de o investigatie radiologica?</h4>
        <p className="text-muted">Programmeaza-te acum la clinica Medimage Lois pentru urmatoarele tipuri de servicii </p>
      </div>
      <Row><p></p></Row>
      <Row>
        <Service title="Ecografie" link="/ecografie"/>
        <Service title="Mamografie" link="/mamografie"/>
        <Service title="Radiologie" link="/radiologie"/>
      </Row>
      <div className="text-center py-5">
        <Button to="/contact" className="btn btn-primary btn-lg">
          Vezi toate investigatiile
        </Button>
      </div>
      <hr></hr>
    </Container>
    <StyledBackground>
      <Container className="py-5">
        <div className="text-center">
          <h4>Intr-o locatie ultra moderna</h4>
          <Hr></Hr>
          <p className="text-muted">
            Clinica de Radiologie si Imagistica Medimage Lois ofera o gama larga de investigatii de inalta performanta avand aparatura noua, 
            performanta Ecograf ,Mamograf , Aparat Röengen. 
            Din grija pentru pacientii nostri, reducem la minim doza de iradiere prin instalarea 
            aplicatiei inteligente LOTUS LAB. Aceasta permite urmarirea dozelor si adaptarea scanarii la nevoile fiecarui pacient, prin minimizarea 
            cantitatii de iradierea la care este expus acesta.
          </p>
          <hr></hr>
        </div>

        <Row>
          <Imagine sursa={Image1}  />
          <Imagine sursa={Image2}  />
        </Row>

      </Container>
    </StyledBackground>
  </Layout>
)

